"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contents_1 = require("../constants/form/contents");
var tailwind_1 = require("../constants/tailwind");
var search_product_form_1 = require("../modules/search_product_form");
var get_element_1 = require("../utils/get_element");
/** ------------------------------------------------------
 * 共通処理
 * ------------------------------------------------------ */
var animeOptions = {
    duration: 300,
    easing: 'ease-in-out',
};
var closingAnime = function (target) { return [
    { marginTop: '1rem', height: target.offsetHeight + 'px' },
    { marginTop: 0, height: 0 },
]; };
var openingAnime = function (target) { return [
    { marginTop: 0, height: 0 },
    { marginTop: '1rem', height: target.offsetHeight + 'px' },
]; };
var animateOpen = function (target) {
    target.style.cssText = contents_1.STYLE_TEXTS.OPTION_OPEN;
    target.animate(openingAnime(target), animeOptions);
};
var animateClose = function (target) {
    var a = target.animate(closingAnime(target), animeOptions);
    a.onfinish = function () { return (target.style.cssText = contents_1.STYLE_TEXTS.OPTION_CLOSE); };
};
/** タブスタイル切替 */
var setActiveTab = function (active, inactive) {
    active.classList.add(tailwind_1.TAILWIND_CLASSES.SEARCH_TAB_BUTTON_ACTIVE);
    inactive.classList.remove(tailwind_1.TAILWIND_CLASSES.SEARCH_TAB_BUTTON_ACTIVE);
};
/** 開閉ボタン UI リセット */
var resetToggleButton = function (icon, text, otherOptions) {
    icon.classList.remove(tailwind_1.TAILWIND_CLASSES.OPEN);
    text.textContent = '開く';
    otherOptions.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
};
/** DOM要素をまとめる（繰返しgetElementを防止） */
var els = {
    warningLabelButton: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.WARNING_LABEL_BUTTON),
    laserLabelButton: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.LASER_LABEL_BUTTON),
    productTypeInput: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.PRODUCT_TYPE_INPUT),
    toggleButton: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.TOGGLE_BUTTON),
    toggleIcon: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.TOGGLE_BUTTON_ICON),
    toggleText: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.TOGGLE_BUTTON_TEXT),
    subOptions: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.WARNING_SUB_OPTIONS),
    laserSubOptions: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.LASER_SUB_OPTIONS),
    otherOptions: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.OTHER_OPTIONS),
};
/** ------------------------------------------------------
 * 商品タイプタブ
 * ------------------------------------------------------ */
var initProductTypeTabClickEvent = function () {
    var emitChange = function () { return els.productTypeInput.dispatchEvent(new Event('change', { bubbles: true })); };
    var bindTab = function (btn) {
        return btn.addEventListener('click', function () {
            els.productTypeInput.value = btn.dataset.value || '';
            emitChange();
        });
    };
    bindTab(els.warningLabelButton);
    bindTab(els.laserLabelButton);
};
/** ------------------------------------------------------
 * 開閉ボタン
 * ------------------------------------------------------ */
var initToggleOpenButtonEvent = function () {
    els.toggleButton.addEventListener('click', function () {
        var isOpen = els.toggleIcon.classList.contains(tailwind_1.TAILWIND_CLASSES.OPEN);
        if (isOpen) {
            // close
            animateClose(els.subOptions);
            animateClose(els.laserSubOptions);
            resetToggleButton(els.toggleIcon, els.toggleText, els.otherOptions);
        }
        else {
            // open
            els.toggleIcon.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
            els.toggleText.textContent = '閉じる';
            els.otherOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
            animateOpen(els.subOptions);
            animateOpen(els.laserSubOptions);
        }
    });
};
/** ------------------------------------------------------
 * SearchProductForm Callbacks
 * ------------------------------------------------------ */
var CONTENTS_SEARCH_CALLBACKS = {
    onProductTypeChange: function (value) {
        var _a;
        var _b;
        var ids = window.eccube.productCategoryIds;
        var handler = (_a = {},
            _a[ids.warningLabel] = function () {
                // 警告ラベル選択時も必ず検索パネルを展開する
                setActiveTab(els.warningLabelButton, els.laserLabelButton);
                els.toggleIcon.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
                els.toggleText.textContent = '閉じる';
                els.otherOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                els.subOptions.style.cssText = contents_1.STYLE_TEXTS.OPTION_OPEN;
                els.laserSubOptions.style.cssText = contents_1.STYLE_TEXTS.OPTION_OPEN;
            },
            _a[ids.laserLabel] = function () {
                setActiveTab(els.laserLabelButton, els.warningLabelButton);
                els.toggleButton.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                els.otherOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                els.laserSubOptions.style.cssText = contents_1.STYLE_TEXTS.OPTION_OPEN;
                els.toggleIcon.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
                els.toggleText.textContent = '閉じる';
                els.otherOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
            },
            _a);
        els.productTypeInput.value = value || '';
        (_b = handler[value]) === null || _b === void 0 ? void 0 : _b.call(handler);
    },
    onLaserStandardTypeChange: function () {
        els.toggleButton.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        els.toggleIcon.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
        els.toggleText.textContent = '閉じる';
        els.otherOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        if (els.laserSubOptions.style.cssText !== contents_1.STYLE_TEXTS.OPTION_OPEN) {
            animateOpen(els.laserSubOptions);
        }
    },
};
/** ------------------------------------------------------
 * 初期化
 * ------------------------------------------------------ */
document.addEventListener('DOMContentLoaded', function () {
    initProductTypeTabClickEvent();
    initToggleOpenButtonEvent();
    new search_product_form_1.SearchProductForm({
        form: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.FORM),
        warningOptions: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.WARNING_OPTIONS),
        childSymbolMark: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.CHILD_SYMBOL_MARK),
        childSymbolMarkArrow: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.CHILD_SYMBOL_MARK_ARROW),
        laserOptions: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.LASER_OPTIONS),
        laserSubOptions: els.laserSubOptions,
        resetButton: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.RESET_BUTTON),
        laserClassRanksContainer: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.LASER_CLASS_RANKS_CONTAINER),
        laserTypesContainer: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.LASER_TYPES_CONTAINER),
        laserWavelengthContainer: (0, get_element_1.getElementById)(contents_1.CONTENTS_SEARCH_IDS.LASER_WAVELENGTH_CONTAINER),
    }, CONTENTS_SEARCH_CALLBACKS);
});
/** メニュークリックイベント */
document.addEventListener('menu-clicked-event', function () {
    if (els.toggleIcon.classList.contains(tailwind_1.TAILWIND_CLASSES.OPEN))
        return;
    els.toggleIcon.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
    els.toggleText.textContent = '閉じる';
    els.otherOptions.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    animateOpen(els.subOptions);
    animateOpen(els.laserSubOptions);
});
